import React from 'react';
import * as SC from './ErrorString.sc';

export const ErrorString = ({ text, height = 'auto' }) => {
  return <SC.Container height={height}>{text}</SC.Container>;
};
